import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Fileform from './attachments/Fileform';
import StepOneForm from './application_details/StepOneForm';
import { useSelector } from 'react-redux';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function CreateConnectionTab() {
  const [value, setValue] = React.useState(0);
  const { navigatable } = useSelector((state) => state.applicationDetails)
 
  const handleChange = (event, newValue) => {
    if (newValue === 1 && navigatable) {
      setValue(newValue);
    }
    if (newValue === 0) {
      setValue(newValue);
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="STEP 1  APPLICATION DETAILS"
            sx={{
              width: { xs: "11em", md: "13em", lg: "25em" },
              height: "auto", backgroundColor: value === 0 ? "#024172" : "#B8B8B8",
              color: value === 0 ? "#FFFFFF !important" : "#E4E4E4 !important",
              margin: "8px", paddingY: "8px", borderRadius: "6px",
              paddingRight: { xs: "32px", lg: "104px" },
              paddingLeft: { xs: "32px", lg: "104px" }
            }}
            {...a11yProps(0)} />
          <Tab label="STEP 2 ATTACHMENTS"
            sx={{
              width: { xs: "11em", md: "13em", lg: "25em" },
              backgroundColor: value === 1 ? "#024172" : "#B8B8B8",
              color: value === 1 ? "#FFFFFF !important" : "#E4E4E4 !important",
              margin: "8px", padding: "8px", borderRadius: "6px",
              paddingRight: { xs: "32px", lg: "104px" }, paddingLeft: { xs: "32px", lg: "104px" }
            }}
            {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <StepOneForm handleChange={handleChange} value={value} setValue={setValue} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Fileform setValue={setValue} />
      </CustomTabPanel>
    </Box>
  );
}